var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_6847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.78498 13.6928C7.2705 13.5631 6.07744 12.2897 6.07744 10.7422C6.07744 9.10884 7.4063 7.77998 9.0397 7.77998C10.0461 7.77998 10.9364 8.28491 11.472 9.05427H22.5312C21.8504 6.92493 20.586 5.01168 18.868 3.54773C16.6894 1.69134 13.9132 0.668945 11.0509 0.668945C8.09911 0.668945 5.32402 1.81846 3.23677 3.90571C2.58211 4.56037 2.01984 5.28271 1.5562 6.0569H2.93452V7.46324H0.846516C0.630656 7.98065 0.454875 8.5147 0.320437 9.06154H2.93452V10.4679H0.0705C0.0242344 10.8806 0 11.2983 0 11.7199C0 15.0968 0.972375 18.3786 2.81198 21.2105L2.82398 21.229L22.2657 23.3311C22.8886 22.6206 23.3677 21.7805 23.6595 20.8826C23.971 19.9239 24.0707 18.8931 23.9507 17.8919H9.81713L8.78498 13.6928Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03932 12.2984C9.89863 12.2984 10.5952 11.6018 10.5952 10.7424C10.5952 9.88313 9.89863 9.18652 9.03932 9.18652C8.18001 9.18652 7.4834 9.88313 7.4834 10.7424C7.4834 11.6018 8.18001 12.2984 9.03932 12.2984Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8162 16.4856L11.675 12.0923C11.3563 12.7119 10.826 13.2055 10.1797 13.4761L10.9194 16.4856H12.8162Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9496 10.8024C22.9311 10.6879 22.9105 10.5741 22.8888 10.4604H12.7041L14.2691 16.4853H23.7537L22.9496 10.8024Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_6847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotr);
export default __webpack_public_path__ + "static/media/MOTR.e88b9dad2855669402c602705859033b.svg";
export { ForwardRef as ReactComponent };